export const containerSpace = ({ theme: { space } }: any) =>
  `padding: ${space[14]}px ${space[24]}px`;
